import { formatDistanceStrict } from 'date-fns';

export const calculateDuration = s => formatDistanceStrict(new Date(s), new Date(), { addSuffix: true });
